import * as yup from "yup";
import { phoneNumberSchema } from "forms/schemas";

export const phoneNumberFormSchema = yup
  .object({
    phoneNumber: phoneNumberSchema,
  })
  .required();
